const routMain = () => '/newsListPage';

export default routMain;